import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bf-auth" }
const _hoisted_2 = { class: "bf-auth__form-wrap" }
const _hoisted_3 = { class: "bf-auth__card" }
const _hoisted_4 = { class: "bf-field" }
const _hoisted_5 = { class: "bf-field" }
const _hoisted_6 = { class: "bf-auth__row" }
const _hoisted_7 = {
  key: 0,
  class: "bf-field mt-4"
}
const _hoisted_8 = { class: "bf-check" }
const _hoisted_9 = {
  key: 0,
  class: "bf-auth__error"
}
const _hoisted_10 = { class: "bf-auth__signup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"bf-auth__brand\" data-v-26ed91da><div class=\"bf-auth__brand-inner\" data-v-26ed91da><img class=\"bf-auth__brand-logo\" src=\"/img/brand/bindfy_logo_new_white.png\" alt=\"Bindfy\" data-v-26ed91da><h2 data-v-26ed91da>Integre seus sistemas sem esforço.</h2><p data-v-26ed91da> Conecte, transforme, distribua e governe seus dados com facilidade e confiança — tudo em um só lugar. </p></div><div class=\"bf-auth__blob bf-auth__blob--1\" data-v-26ed91da></div><div class=\"bf-auth__blob bf-auth__blob--2\" data-v-26ed91da></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[15] || (_cache[15] = _createElementVNode("img", {
          class: "bf-auth__logo-mobile",
          src: "/img/brand/bindfy_logo_new_purple.png",
          alt: "Bindfy"
        }, null, -1)),
        _cache[16] || (_cache[16] = _createElementVNode("h1", { class: "bf-auth__title" }, "Bem-vindo de volta", -1)),
        _cache[17] || (_cache[17] = _createElementVNode("p", { class: "bf-auth__desc" }, "Acesse sua conta para continuar", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[6] || (_cache[6] = _createElementVNode("label", null, "E-mail", -1)),
            _createVNode(_component_TextInput, {
              label: 'Digite o seu e-mail',
              type: 'email',
              modelValue: _ctx.signInForm.login,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signInForm.login) = $event)),
              "error-messages": 
                _ctx.v$.login.$errors ? _ctx.v$.login.$errors[0]?.$message : undefined
              
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("label", null, "Senha", -1)),
            _createVNode(_component_TextInput, {
              label: 'Digite a sua senha',
              type: 'password',
              modelValue: _ctx.signInForm.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signInForm.password) = $event)),
              "error-messages": 
                _ctx.v$.password.$errors
                  ? _ctx.v$.password.$errors[0]?.$message
                  : undefined
              
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_checkbox, {
              "hide-details": "",
              color: "primary",
              density: "compact",
              modelValue: _ctx.signInForm.remember,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signInForm.remember) = $event)),
              label: "Lembrar deste acesso"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_router_link, {
              to: "/autenticar/esqueci-minha-senha",
              class: "bf-link"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" Esqueceu a senha? ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createVNode(_component_PrimaryButton, {
            class: "mt-0",
            "is-loading": _ctx.isLoading,
            label: "Entrar"
          }, null, 8, ["is-loading"]),
          (_ctx.mfaRequired)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[10] || (_cache[10] = _createElementVNode("label", null, "Código MFA", -1)),
                _createVNode(_component_TextInput, {
                  modelValue: _ctx.mfaCode,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mfaCode) = $event)),
                  label: "Código de 6 dígitos",
                  maxlength: "6",
                  "input-attrs": { autocomplete: 'one-time-code' }
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.trustDevice) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.trustDevice]
                  ]),
                  _cache[9] || (_cache[9] = _createTextVNode(" Confiar neste dispositivo ", -1))
                ]),
                (_ctx.mfaError)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.mfaError), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_PrimaryButton, {
                  "is-loading": _ctx.isLoading,
                  label: "Verificar MFA",
                  onClick: _ctx.handleVerifyMfa
                }, null, 8, ["is-loading", "onClick"])
              ]))
            : _createCommentVNode("", true),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "bf-auth__divider" }, [
            _createElementVNode("span", null, "ou")
          ], -1)),
          _cache[14] || (_cache[14] = _createElementVNode("div", {
            id: "google-signin-button",
            class: "bf-auth__google"
          }, null, -1)),
          _createElementVNode("div", _hoisted_10, [
            _cache[12] || (_cache[12] = _createTextVNode(" Não tem uma conta? ", -1)),
            _createVNode(_component_router_link, {
              to: "/autenticar/criar-conta",
              class: "bf-link"
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode(" Crie uma aqui ", -1)
              ]))]),
              _: 1
            })
          ])
        ], 32)
      ])
    ])
  ]))
}